import { render, staticRenderFns } from "./UserInputButton.vue?vue&type=template&id=1557ae70&scoped=true&"
import script from "./UserInputButton.vue?vue&type=script&lang=js&"
export * from "./UserInputButton.vue?vue&type=script&lang=js&"
import style0 from "./UserInputButton.vue?vue&type=style&index=0&id=1557ae70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1557ae70",
  null
  
)

export default component.exports